<div class="auth-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center mt-2">
              <h5 class="text-primary">Two-Factor Authentication Setup</h5>
              <p class="text-muted">Scan the QR code with your authenticator app</p>
            </div>
            
            <div class="p-2 mt-4">
              <div class="text-center mb-4" *ngIf="isLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              
              <div class="text-center mb-4" *ngIf="qrCodeUrl && !isLoading">
                <img [src]="qrCodeUrl" alt="2FA QR Code" class="img-fluid" style="max-width: 250px;">
                <p class="mt-3 text-muted">
                  Scan this QR code with Google Authenticator, Microsoft Authenticator, or any other compatible app.
                </p>
              </div>
              
              <div class="mb-3">
                <label for="verificationCode" class="form-label">Verification Code</label>
                <input type="text" class="form-control" id="verificationCode" 
                  placeholder="Enter 6-digit code" [(ngModel)]="verificationCode" 
                  maxlength="6" pattern="[0-9]*" inputmode="numeric">
                <div class="form-text">
                  Enter the 6-digit code from your authenticator app
                </div>
              </div>
              
              <div class="mt-3 d-grid">
                <button class="btn btn-primary" type="button" 
                  [disabled]="isLoading || !verificationCode" 
                  (click)="verifyCode()">
                  Verify & Complete Setup
                </button>
              </div>
              
              <div class="mt-2 text-center">
                <button class="btn btn-primary" type="button" 
                [disabled]="isLoading || !verificationCode"
                
                (click)="cancel()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>